module.exports = __webpack_public_path__ + "images/柏纳s长图_04-4.jpg?v=da3e232c";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan2/柏纳s长图_04-4.jpg
 ** module id = 162
 ** module chunks = 1 2
 **/